<template>
  <div class="row">
    <div
      class="my-2"
      :class="(namaRole != 'Penduduk' && mode === 'data-permohonan') ? 'col-lg-9' : 'col-12'"
    >
      <div style="overflow:auto">
        <!-- filter penduduk -->
        <ul
          class="nav nav-pills nav-pills-sm hover white-space-no-wrap"
          v-if="namaRole === 'Penduduk'"
        >
          <li class="nav-item">
            <a
              class="nav-link disabled text-dark"
              href="#"
            ><b>Status</b></a>
          </li>
                            
                            
          <!-- ini bisa disederhanain -->
          <li
            class="nav-item"
            v-for="s in widgetStatus"
            :key="s.id"
          >
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 0}"
              v-if="s.status === 0"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Belum Diajukan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 1}"
              v-if="s.status === 1"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diajukan ke Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 2}"
              v-if="s.status === 2"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 3}"
              v-if="s.status === 3"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 4}"
              v-if="s.status === 4"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 5}"
              v-if="s.status === 5"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diajukan ke Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 6}"
              v-if="s.status === 6"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 7}"
              v-if="s.status === 7"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 8}"
              v-if="s.status === 8"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 9}"
              v-if="s.status === 9"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diajukan ke Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 10}"
              v-if="s.status === 10"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 11}"
              v-if="s.status === 11"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 12}"
              v-if="s.status === 12"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 13}"
              v-if="s.status === 13"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Dibatalkan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 14}"
              v-if="s.status === 14"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Valid Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 15}"
              v-if="s.status === 15"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Berkas Siap<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 16}"
              v-if="s.status === 16"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Selesai<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === null}"
              href="javascript:void(0)"
              @click="$emit('filterStatus', null)"
            >Semua <span class="badge badge-secondary text-dark">{{ numAllPermohonan }}</span></a>
          </li>
        </ul>
                        
        <!-- filter desa -->
        <ul
          class="nav nav-pills nav-pills-sm hover white-space-no-wrap"
          v-else-if="namaRole === 'Operator Desa' || namaRole === 'Kepala Desa' || namaRole === 'Rumah Sakit'"
        >
          <li class="nav-item">
            <a
              class="nav-link disabled text-dark"
              href="#"
            ><b>Status</b></a>
          </li>
                            
          <li
            class="nav-item"
            v-for="s in widgetStatus"
            :key="s.id"
          >
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 1}"
              v-if="s.status === 1"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Belum diproses<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 2}"
              v-if="s.status === 2"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Sedang diproses<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 3}"
              v-if="s.status === 3"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 4}"
              v-if="s.status === 4"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 5}"
              v-if="s.status === 5"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Valid<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 6}"
              v-if="s.status === 6"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 7}"
              v-if="s.status === 7"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 8}"
              v-if="s.status === 8"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 9}"
              v-if="s.status === 9"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diajukan ke Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 10}"
              v-if="s.status === 10"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 11}"
              v-if="s.status === 11"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 12}"
              v-if="s.status === 12"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 13}"
              v-if="s.status === 13"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Dibatalkan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 14}"
              v-if="s.status === 14"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Valid Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 15}"
              v-if="s.status === 15"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Berkas Siap<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 16}"
              v-if="s.status === 16"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Selesai<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === null}"
              href="javascript:void(0)"
              @click="$emit('filterStatus', null)"
            >Semua <span class="badge badge-secondary text-dark">{{ numAllPermohonan }}</span></a>
          </li>
        </ul>

        <!-- filter kecamatan -->
        <ul
          class="nav nav-pills nav-pills-sm hover white-space-no-wrap"
          v-else-if="namaRole === 'Operator Kecamatan'"
        >
          <li class="nav-item">
            <a
              class="nav-link disabled text-dark"
              href="#"
            ><b>Status</b></a>
          </li>
                            
          <li
            class="nav-item"
            v-for="s in widgetStatus"
            :key="s.id"
          >
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 1}"
              v-if="s.status === 1"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diajukan ke Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 2}"
              v-if="s.status === 2"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 3}"
              v-if="s.status === 3"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 4}"
              v-if="s.status === 4"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 5}"
              v-if="s.status === 5"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Belum diproses<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 6}"
              v-if="s.status === 6"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Sedang diproses<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 7}"
              v-if="s.status === 7"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 8}"
              v-if="s.status === 8"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 9}"
              v-if="s.status === 9"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Valid<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 10}"
              v-if="s.status === 10"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 11}"
              v-if="s.status === 11"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 12}"
              v-if="s.status === 12"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 13}"
              v-if="s.status === 13"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Dibatalkan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 14}"
              v-if="s.status === 14"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Valid Dukcapil<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 15}"
              v-if="s.status === 15"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Berkas Siap<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 16}"
              v-if="s.status === 16"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Selesai<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === null}"
              href="javascript:void(0)"
              @click="$emit('filterStatus', null)"
            >Semua <span class="badge badge-secondary text-dark">{{ numAllPermohonan }}</span></a>
          </li>
        </ul>

        <!-- filter dukcapil -->
        <ul
          class="nav nav-pills nav-pills-sm hover white-space-no-wrap"
          v-else-if="namaRole === 'Operator Dukcapil' || namaRole === 'Operator Dukcapil Kecamatan' || namaRole === 'Admin Laksita' || namaRole === 'Admin Jembrana'"
        >
          <li class="nav-item">
            <a
              class="nav-link disabled text-dark"
              href="#"
            ><b>Status</b></a>
          </li>
                            
          <li
            class="nav-item"
            v-for="s in widgetStatus"
            :key="s.id"
          >
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 0}"
              v-if="s.status === 0"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Belum Diajukan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 1}"
              v-if="s.status === 1"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diajukan ke Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 2}"
              v-if="s.status === 2"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 3}"
              v-if="s.status === 3"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 4}"
              v-if="s.status === 4"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Desa<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 5}"
              v-if="s.status === 5"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diajukan ke Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 6}"
              v-if="s.status === 6"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Diproses di Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 7}"
              v-if="s.status === 7"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi tingkat Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 8}"
              v-if="s.status === 8"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak Kecamatan<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 9}"
              v-if="s.status === 9"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Belum diproses<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 10}"
              v-if="s.status === 10"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Sedang diproses<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 11}"
              v-if="s.status === 11"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Revisi<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 12}"
              v-if="s.status === 12"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Ditolak<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 14}"
              v-if="s.status === 14"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Valid<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 15}"
              v-if="s.status === 15"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Berkas Siap<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === 16}"
              v-if="s.status === 16"
              href="javascript:void(0)"
              @click="$emit('filterStatus', s.status)"
            >Selesai<span class="badge badge-secondary text-dark">{{ s.num }}</span></a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              :class="{'active': filterPermohonan.status === null}"
              href="javascript:void(0)"
              @click="$emit('filterStatus', null)"
            >Semua <span class="badge badge-secondary text-dark">{{ numAllPermohonan }}</span></a>
          </li>
        </ul>
      </div>
    </div>
    <div
      v-if="namaRole != 'Penduduk' && mode === 'data-permohonan'"
      class="col-lg-3 my-2"
    >
      <button
        @click="showFilter = !showFilter"
        class="btn btn-block"
        :class="(showFilter) ? 'btn-danger' : 'btn-primary'"
      >
        {{ (showFilter) ? 'Sembunyikan' : 'Tampilkan' }} Filter
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      showFilter: false
    }
  },
  props: {
    mode: {
      type: String,
      default: () => null
    },
    numAllPermohonan: {
      type: Number,
      default: () => null
    },
    widgetStatus: {
      type: Array,
      default: () => null
    },
    showFilterData: {
      type: Boolean,
      default: () => null
    }
  },
  computed: {
    permohonan() {
      return this.$store.getters.getPermohonan
    },
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    },
    filterPermohonan() {
      return this.$store.getters.getFilterPermohonan
    },
  },
  mounted () {
    this.showFilter = this.showFilterData
  },
  watch: {
    showFilter (newVal) {
      this.$emit('setShowFilter', newVal)
    },
    showFilterData (newVal) {
      this.showFilter = newVal
    }
  }
}
</script>